import { api } from '../config/api';

export const dashboardService = {
  getStats: async () => {
    return api.get('/api/dashboard/stats');
  },
  
  getActivity: async (limit = 10) => {
    return api.get(`/api/dashboard/activity?limit=${limit}`);
  },
  
  getCertificationAlerts: async () => {
    return api.get('/api/dashboard/certification-alerts');
  }
};
